import { Record, Map } from 'immutable';
import { actionTypes } from './touchpoint-settings.actions';
import { Err } from '../../err';


export const SettingsState = Record({
  err: null,
  isFetching: false,
  isValid: false,
  data: null
});

export const SettingsSubmissionState = Record({
  err: null,
  isSubmitting: false,
  data: null
});

export const FormSiteSettings = Record({
  settings: Map({}),
  settingsResponses: Map({}),
  settingsSubmission: Map({})
});

export const touchpointSettingsReducer = (state = new FormSiteSettings(), action) => {
  switch (action.type) {
    case actionTypes.FETCH_SETTINGS_BEGIN:
      return state.setIn(['settings', action.siteId, action.formId], new SettingsState({
        isFetching: true
      }));
    case actionTypes.FETCH_SETTINGS_SUCCESS:
      return state.setIn(['settings', action.siteId, action.formId], new SettingsState({
        data: action.data,
        isValid: true
      }));
    case actionTypes.FETCH_SETTINGS_FAILURE:
      return state.setIn(['settings', action.siteId, action.formId], new SettingsState({
        err: new Err(action.err),
        isValid: true
      }));
    case actionTypes.UPDATE_ALIAS:
      return state.setIn(['settingsResponses', action.siteId, action.formId], action.value);
    case actionTypes.SUBMIT_SETTINGS_BEGIN:
      return state.setIn(['settingsSubmission', action.siteId], new SettingsSubmissionState({
        isSubmitting: true
      }));
    case actionTypes.SUBMIT_SETTINGS_SUCCESS:
      return state.setIn(['settingsSubmission', action.siteId], new SettingsSubmissionState({
        data: action.data
      }));
    case actionTypes.SUBMIT_SETTINGS_FAILURE:
      return state.setIn(['settingsSubmission', action.siteId], new SettingsSubmissionState({
        err: new Err(action.err)
      }));
    default:
      return state
  }
}
